import { render } from "./VideoHint.vue?vue&type=template&id=13f5af48"
import script from "./VideoHint.vue?vue&type=script&lang=ts"
export * from "./VideoHint.vue?vue&type=script&lang=ts"

import "./VideoHint.vue?vue&type=style&index=0&id=13f5af48&lang=scss"
script.render = render

export default script